var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('nav',{staticClass:"banner"},[_c('banner-left'),_c('banner-right')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }